import * as React from "react";
import { useMemo } from "react";
import styled from "styled-components";
import { MenuItem, Button, ControlLabel } from "components/bootstrap";
import { Icon } from "components/common";
import { useSelectedRows, useSelectedRowsDispatch } from "common/contexts";
import { GLCheckbox, Col, Row } from "common/components";
import useEventBulkActions from "components/events/events/hooks/useEventBulkActions";
import { DropdownMenu } from "security-app/components/common";
import { isPermitted } from "util/PermissionsMixin";
import useCurrentUser from "hooks/useCurrentUser";
import useReplayBulkAction from "components/events/events/hooks/useReplayBulkAction";
const IconContainer = styled.div`
  width: 16px;
  display: inline-block;
  text-align: left;
`;
const SelectAll = styled(Row)`
  padding: ${({ theme }) => theme.spacings.xs} ${({ theme }) => theme.spacings.sm};

  & > label {
    margin: 0;
  }
`;
function BulkActions({ secEvents = [] }) {
  const selectedSecEvents = useSelectedRows();
  const selectedSecEventsDispatch = useSelectedRowsDispatch();
  const { actions, pluggableActionModals } = useEventBulkActions(selectedSecEvents);
  const currentUser = useCurrentUser();
  const eventsWithReplayInfo = selectedSecEvents.filter(
    (event) => !!event.replay_info && isPermitted(currentUser == null ? void 0 : currentUser.permissions, `eventdefinitions:read:${event.id}`)
  );
  const onReplaySearchClick = useReplayBulkAction(eventsWithReplayInfo);
  const clearSelection = (e) => {
    e.stopPropagation();
    selectedSecEventsDispatch({ type: "clear" });
  };
  const allSelected = useMemo(
    () => secEvents.length > 0 && selectedSecEvents.length > 0 && secEvents.every(
      (secEvent) => !!selectedSecEvents.find((sSecEvent) => secEvent.event_id === sSecEvent.event_id)
    ),
    [secEvents, selectedSecEvents]
  );
  const selectAll = (e) => {
    if (e.target.checked) {
      selectedSecEventsDispatch({ type: "add", payload: secEvents });
    } else {
      selectedSecEventsDispatch({ type: "remove", payload: secEvents });
    }
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Col, null, /* @__PURE__ */ React.createElement(
    DropdownMenu,
    {
      trigger: /* @__PURE__ */ React.createElement(Button, { bsSize: "sm", disabled: selectedSecEvents.length < 1 }, /* @__PURE__ */ React.createElement(IconContainer, null, /* @__PURE__ */ React.createElement(Icon, { name: "arrow_drop_down", size: "sm" })), "Bulk Actions ", selectedSecEvents.length > 0 ? selectedSecEvents.length : null, selectedSecEvents.length > 0 && /* @__PURE__ */ React.createElement(IconContainer, { onClick: clearSelection, style: { marginLeft: 10 } }, /* @__PURE__ */ React.createElement(Icon, { name: "close" })))
    },
    eventsWithReplayInfo.length > 0 && /* @__PURE__ */ React.createElement(MenuItem, { onClick: onReplaySearchClick }, "Replay Search"),
    actions
  ), /* @__PURE__ */ React.createElement(SelectAll, { $align: "center", $gap: "xs" }, /* @__PURE__ */ React.createElement(GLCheckbox, { checked: allSelected, onChange: selectAll, title: "Select all sigma rules" }), /* @__PURE__ */ React.createElement(ControlLabel, null, "Select All"))), pluggableActionModals);
}
export default BulkActions;
